import * as React from "react"
import { useRef } from "react"
import * as yup from "yup"
import _ from "lodash"
import { Appearance, TextInput, ViewStyle } from "react-native"
import { FastField, Formik } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import { FormProps } from "../form"
import { NumeralInput, NumeralInputProps } from "../../input/numeral-input/numeral-input"
import { TxKeyPath } from "../../../i18n"
import { observer } from "mobx-react-lite"

const FORM_CONTROL: ViewStyle = {
  marginBottom: 4
}

export interface PondNumberFormProps extends FormProps {
  initialValues?: {
    number?: number
  },
  formControlProps?: FormControlProps,
  numeralInputProps?: NumeralInputProps
}

/**
 * Describe your component here
 */
export const PondNumberForm = observer(function PondNumberForm(props: PondNumberFormProps) {

  const { initialValues = {}, onSubmit, colorScheme = Appearance.getColorScheme(), innerRef, formControlProps , numeralInputProps, ...rest } = props
  const input = {
    number: useRef<TextInput>(),
  }

  const validationSchema = yup.object({
    number: yup.number().min(1, "The minimum amount is one").required(),
  })

  return (
    <Formik
      initialValues={{
        number: '',
        ...initialValues
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ isValid, handleSubmit }) => (
        <>
          <FastField name="number">
            {({ field, form: { setFieldValue, handleBlur }, meta }) => (
              <FormControl
                isInvalid={meta.touched && !!meta.error}
                labelTx={`farmPondListScreen.${_.camelCase(field.name)}` as TxKeyPath}
                colorScheme={colorScheme}
                inputProps={{
                  testID: `jala:id/${field.name}-input`,
                  ref: input[field.name],
                  autoCapitalize: "none",
                  autoComplete: "off",
                  autoCorrect: false,
                  textContentType: "none",
                  keyboardType: "numeric",
                  // returnKeyType: nextInput[field.name] ? "next" : "go",
                  // onSubmitEditing: () => nextInput[field.name] ? nextInput[field.name]() : (isValid && handleSubmit()),
                  onSubmitEditing: () => (isValid && handleSubmit()),
                  placeholder: "0",
                  defaultValue: field.value,
                  onBlur: handleBlur(field.name),
                }}
                errorMessage={meta.error}
                style={FORM_CONTROL}
                {...formControlProps}
              >
                {(inputProps) => (
                  <NumeralInput colorScheme={colorScheme}
                    onChangeNumber={(value) => setFieldValue(field.name, value)} {...inputProps} {...numeralInputProps} />
                )}
              </FormControl>
            )}
          </FastField>
        </>
      )}
    </Formik>
  )
})

PondNumberForm.displayName = 'PondNumberForm'
